module.exports = __webpack_public_path__ + "img/Flunder_3.4da0e8a7.jpg";